// @flow
import React, { Fragment, PureComponent } from 'react';
import type { EventType, EventMatchType } from 'types/Event';
import EventListElementWrapper from 'containers/event/EventListElementWrapperContainer';
import { dynamicClassName } from 'utils/dynamicClassName';

type Props = {
  events: Array<EventType | EventMatchType>
};

type State = {
  isOpen: boolean
};

class HiddenEventListElement extends PureComponent<Props, State> {
  props: Props;
  state: State = {
    isOpen: false
  };

  handleHiddenMenuClicked = (e: MouseEvent) => {
    e.preventDefault();
    this.setState({ isOpen: !this.state.isOpen });
  };

  renderEvents = (): any => {
    return this.props.events.map((event, index) => (
      <EventListElementWrapper key={`${event.title}${index}`} event={event} />
    ));
  };

  render() {
    const classNamesContainer = dynamicClassName('accordion-panel');
    !this.state.isOpen && classNamesContainer.add('is-hidden');

    const classNamesTrigger = dynamicClassName(
      'link-chevron link-chevron--block link-chevron--center link-chevron--inline accordion-trigger'
    );
    this.state.isOpen && classNamesTrigger.add('is-selected');

    return (
      <Fragment>
        <div className={classNamesContainer.build()}>{this.renderEvents()}</div>
        <a
          onClick={this.handleHiddenMenuClicked}
          role="button"
          tabIndex={0}
          title="Plus"
          className={classNamesTrigger.build()}
          data-label="TBD => sûr ? Masquer les événements"
        >
          {/* TODO : verifier l'utilité de data label*/}
          <span>{this.props.events.length} autres événements</span>
          <i className="icon icon-zoom_plus" />
        </a>
      </Fragment>
    );
  }
}

export default HiddenEventListElement;
